import __base_store from '@/store/__base_store'

/**
 * Store de configuración online (modelo `online_configuration`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'online_configuration',
	},
})

